import { OperatorSystemUsageDetailPage } from "@/components/system-usage/operator-system-usage-detail-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/system-usage/$userId")({
  validateSearch: (search: Record<string, unknown>) => ({
    from: typeof search.from === "string" ? search.from : undefined,
    to: typeof search.to === "string" ? search.to : undefined,
  }),
  component: SystemUsageDetailRoute,
});

function SystemUsageDetailRoute() {
  const { userId } = Route.useParams();
  const { from, to } = Route.useSearch();
  return (
    <OperatorSystemUsageDetailPage
      userId={userId}
      initialFrom={from}
      initialTo={to}
    />
  );
}
